import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

export default mockComponentRenderProp('DropClick', null, { withChildren: true });
